import { Component, HostListener } from '@angular/core';
import { Globals } from './globals';
import { Location, CommonModule } from '@angular/common';
import { ModalProductoDetalleComponent } from './componentes/modal-producto-detalle/modal-producto-detalle.component';
import { MatDialog } from '@angular/material/dialog';
import { RouteStorageService } from './services/route-storage.service';
import { NavigationExtras, Router } from '@angular/router';
// Importa el servicio
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app-angular';
 
	constructor(
		public globals: Globals,
		private router: Router,
		private location: Location,
		public dialog: MatDialog,
		private routeStorageService: RouteStorageService // Inyecta el servicio
	) { 

		
		const lastRoute = localStorage.getItem('lastRoute');
		if(lastRoute == '/'){
			localStorage.setItem('busqueda','')
			localStorage.setItem('paginaActual','1')
			this.globals.configuracion.front.listado.busqueda = ''
		}
		// alert(lastRoute)
		if (lastRoute) {
			let busqueda = localStorage.getItem('busqueda')

			if (this.router.url !== '/catalogo' && busqueda) {
				const parametros = {
				value: busqueda,
				buscar:true
				};
			
				// Crear un objeto de tipo NavigationExtras y asignar los parámetros
				const navigationExtras: NavigationExtras = {
				queryParams: parametros,
				};
				// console.log('parametros',parametros)
				this.router.navigate([`/catalogo`],navigationExtras);
			
				// Redirigir al usuario a la vista del catálogo
				// this.router.navigateByUrl('/catalogo');
			}
		  	// this.router.navigateByUrl(lastRoute);
		}
	}
	
	@HostListener('window:popstate', ['$event'])
	onPopState(event: any) {
	  event.preventDefault();
	  localStorage.setItem('popstate','true'); 
	
	}
	cerrarModal(){
		this.globals.drawerObject.open = false;
	}

	onResize(event?) {
    
	}

	
}
